export default __webpack_public_path__ + "static/DNGResidential_4-9c9d3ea629477af4ee1fc243f0ba3520.jpg";